import { render, staticRenderFns } from "./News_ipos.vue?vue&type=template&id=c3d5e8d8&scoped=true&"
import script from "./News_ipos.vue?vue&type=script&lang=js&"
export * from "./News_ipos.vue?vue&type=script&lang=js&"
import style0 from "./News_ipos.vue?vue&type=style&index=0&id=c3d5e8d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d5e8d8",
  null
  
)

export default component.exports